import React, { useState, useEffect, useContext, useRef } from 'react'
import { useParams } from 'react-router-dom'
import {
    Card,
    CardBody,
    Row,
    Col,
    // Button,
    Form,
    Label,
    FormGroup,
    Input,
    Table,
    Badge,
    Alert
} from 'reactstrap'

import {
    Button,
    Dropdown,
    ButtonGroup,
    // DropdownButton
} from 'react-bootstrap'

import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import CurrencyFormat from 'react-currency-format'
import Select from "react-select"
import { numberFormat } from '../../../helpers/Currency'
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { head, isEmpty } from 'lodash'
import Moment from 'moment'
import 'moment/min/locales'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import Modal from "../../../components/Modal"
import LineItemForm from './LineItemForm'
import ProgramarFacturaModal from './ProgramarFacturaModal'
import BillingPaywallModal from '../../../components/pagos/BillingPaywallModal'

import {
    usoCfdiValores,
    formaPagoValores,
    ObjetoImpCatalogo,
    c_Periodicidad,
    c_Meses,
    MetodoPagoValores,
    CondicionesDePagoValores,
    StatusDePagoValores,
    MonedaValores,
    c_TipoRelacion
} from '../../../data/catalogs/CatalogosSAT'
import { getDuplicatedFacturaFormState } from '../../../helpers/duplicarFactura'
import { buildCerrarSaldoPrefill } from '../../../helpers/cerrarSaldoHelper'

Moment.locale('es')

const FormPage = (props) => {
    const PEDIMENTO_REGEX = /^\d{2} \d{2} \d{4} \d{7}$/
    const OBJETO_IMP_OBJETO = '02'
    const OBJETO_IMP_NO_OBJETO = '01'
    const IVA_EXENTO_TIPO_FACTOR = 'Exento'

    const getDefaultTempItem = () => ({
        claveProdServ: '',
        descripcion: '',
        claveUnidad: '',
        noIdentificacion: '',
        cantidad: 1,
        valorUnitario: 0,
        importe: 0,
        descuento: 0,
        impuestosTrasladados: 0,
        retenciones: 0,
        total: 0,
        InformacionAduanera: '',
        CuentaPredial: '',
        ObjetoImp: { value: '02', label: '(02) Objeto de impuesto' }
    })

    const impuestos = {
        trasladados: [
            {
                label: 'IVA 16%',
                value: [{
                    tasa: 0.16,
                    tasaLabel: '0.160000',
                    code: '002'
                }]
            },
            {
                label: 'IVA 8%',
                value: [{
                    tasa: 0.08,
                    tasaLabel: '0.080000',
                    code: '002'
                }]
            },
            {
                label: 'IVA 0%',
                value: [{
                    tasa: 0,
                    tasaLabel: '0.000000',
                    code: '002'
                }]
            },
            {
                label: 'IVA Exento',
                value: [{
                    code: '002',
                    tipoFactor: IVA_EXENTO_TIPO_FACTOR
                }]
            }
        ],
        retenciones: [
            {
                value: false,
                label: 'N/A'
            },
            {
                label: 'ISR 10%',
                value: [{
                    code: '001',
                    tasa: 0.100000,
                    tasaLabel: '0.100000'
                }]
            },
            {
                label: 'IVA 10.6667%',
                value: [{
                    code: '002',
                    tasa: 0.106667,
                    tasaLabel: '0.106667'
                }]
            },
            {
                label: 'ISR 1.25%',
                value: [{
                    code: '001',
                    tasa: 0.0125000,
                    tasaLabel: '0.012500'
                }]
            },
            {
                label: 'IVA 10.6667% / ISR 1.25%',
                value: [{
                    code: '002',
                    tasa: 0.106667,
                    tasaLabel: '0.106667'
                }, {
                    code: '001',
                    tasa: 0.0125000,
                    tasaLabel: '0.012500'
                }]
            },
            {
                label: 'IVA 10.6667% / ISR 10%',
                value: [{
                    code: '002',
                    tasa: 0.106667,
                    tasaLabel: '0.106667'
                }, {
                    code: '001',
                    tasa: 0.100000,
                    tasaLabel: '0.100000'
                }]
            }
        ]
    }

    const { id } = useParams() // facturaId
    const generalContext = useContext(GeneralContext)
    const { loading, setLoading } = generalContext

    const [lugares, setLugares] = useState([])
    const [clientes, setClientes] = useState([])
    const [servicios, setServicios] = useState([])
    const [certificado, setCertificado] = useState('')
    const [unidades, setUnidades] = useState([])
    const [claves, setClaves] = useState([])
    const [aduanas, setAduanas] = useState([])
    const [patentes, setPatentes] = useState([])
    const [autosuggest, setAutosuggest] = useState([])
    const [aduanaAutosuggest, setAduanaAutosuggest] = useState([])
    const [patenteAutosuggest, setPatenteAutosuggest] = useState([])
    const [isAddClaveModalOpen, setIsAddClaveModalOpen] = useState(false)
    const [isAddClaveUnidadModalOpen, setIsAddClaveUnidadModalOpen] = useState(false)
    const [isAddAduanaModalOpen, setIsAddAduanaModalOpen] = useState(false)
    const [isAddPatenteModalOpen, setIsAddPatenteModalOpen] = useState(false)
    const [pendingStampRequest, setPendingStampRequest] = useState(null)

    const autosuggestRef = useRef()
    const aduanaAutosuggestRef = useRef()
    const patenteAutosuggestRef = useRef()

    const [lugarExpedicion, setLugarExpedicion] = useState({})
    const [cliente, setCliente] = useState()
    const [condicionesPago, setCondicionesPago] = useState({
        label: 'Contado',
        value: 'CONTADO'
    })
    const [moneda, setMoneda] = useState({
        label: '(MXN) Pesos Mexicanos',
        value: 'MXN'
    })
    const [tipoCambio, setTipoCambio] = useState()
    const [tipoDeComprobante, setTipoDeComprobante] = useState('I')
    const [usoCFDI, setUsoCFDI] = useState({
        value: 'G03',
        label: 'Gastos en general'
    })
    const [formaPago, setFormaPago] = useState({ value: '03', label: 'Transferencia electrónica de fondos' })
    const [pagada, setPagada] = useState({
        label: 'Pagada',
        value: true
    })
    const [metodoPago, setMetodoPago] = useState({
        label: 'PUE - Pago en una sola exhibición',
        value: 'PUE'
    })
    const [_id, setId] = useState()
    const [lineItems, setLineItems] = useState([])
    const [tempItem, setTempItem] = useState(getDefaultTempItem())
    const [editTempItem, setEditTempItem] = useState(getDefaultTempItem())
    const [isEditLineItemModalOpen, setIsEditLineItemModalOpen] = useState(false)
    const [editingLineItemIndex, setEditingLineItemIndex] = useState(null)

    const [servicio, setServicio] = useState('')
    const [totales, setTotales] = useState({
        subtotal: 0,
        traslados: [],
        retenciones: [],
        total: 0,
        descuentos: 0
    })

    const [informacionGlobal, setInformacionGlobal] = useState({
        Periodicidad: {
            value: '04',
            label: 'Mensual'
        },
        Meses: c_Meses.find(i => i.value === Moment().format('MM')),
        Año: {
            value: Moment().format('Y'),
            label: Moment().format('Y')
        }
    })
    const [showInformacionGlobalForm, setShowInformacionGlobalForm] = useState(false)
    const [isModalPreviewOpen, setIsModalPreviewOpen] = useState(false)
    const [previewPDF, setPreviewPDF] = useState(null)
    const [scheduleStatus, setScheduleStatus] = useState()
    const [scheduleErrorReason, setScheduleErrorReason] = useState('')
    const [currentSchedule, setCurrentSchedule] = useState(null)
    const [programarFacturaModalOpen, setProgramarFacturaModalOpen] = useState(false)
    const [facturaIdToSchedule, setFacturaIdToSchedule] = useState()

    // CFDI Relacionados state
    const [cfdiRelacionados, setCfdiRelacionados] = useState([])
    const [showCfdiRelacionadosForm, setShowCfdiRelacionadosForm] = useState(false)
    const [isAddRelacionModalOpen, setIsAddRelacionModalOpen] = useState(false)
    const [newRelacionTipoRelacion, setNewRelacionTipoRelacion] = useState(c_TipoRelacion[0])

    // Cerrar saldo pendiente state
    const [_sourceFacturaId, setSourceFacturaId] = useState(null)
    const [replacementContext, setReplacementContext] = useState(null)
    // Modal browse state
    const [modalRelacionFacturas, setModalRelacionFacturas] = useState([])
    const [modalRelacionSearch, setModalRelacionSearch] = useState('')
    const [modalRelacionCliente, setModalRelacionCliente] = useState(null)
    const [modalRelacionLoading, setModalRelacionLoading] = useState(false)
    const [modalRelacionPage, setModalRelacionPage] = useState(1)
    const [modalRelacionTotalPages, setModalRelacionTotalPages] = useState(1)
    const [modalRelacionTotal, setModalRelacionTotal] = useState(0)
    const [modalRelacionPastYears, setModalRelacionPastYears] = useState(false)
    const debounceRelacionRef = useRef(null)
    // Confirm-change-customer dialog for relacionados
    const [isConfirmRelacionModalOpen, setIsConfirmRelacionModalOpen] = useState(false)
    const [pendingRelacion, setPendingRelacion] = useState(null)

    const closeModal = () => {
        setIsModalPreviewOpen(!isModalPreviewOpen)
    }

    const closeAddClaveModal = () => {
        setIsAddClaveModalOpen(!isAddClaveModalOpen)
    }

    const closeAddClaveUnidadModal = () => {
        setIsAddClaveUnidadModalOpen(!isAddClaveUnidadModalOpen)
    }

    const closeAddAduanaModal = () => {
        setIsAddAduanaModalOpen(!isAddAduanaModalOpen)
        setAduanaAutosuggest([])
    }

    const closeAddPatenteModal = () => {
        setIsAddPatenteModalOpen(!isAddPatenteModalOpen)
        setPatenteAutosuggest([])
    }

    const closeEditLineItemModal = () => {
        setIsEditLineItemModalOpen(false)
        setEditingLineItemIndex(null)
        setEditTempItem(getDefaultTempItem())
    }

    const _fetchFacturasTimbradas = async (page, clienteId, search, pastYears) => {
        setModalRelacionLoading(true)
        try {
            const params = { page, limit: 10 }
            if (clienteId) params.clienteId = clienteId
            if (search)    params.search    = search
            if (pastYears) params.includePastYears = true
            const { data } = await ApiService.getFacturasTimbradas(params)
            setModalRelacionFacturas(data?.data || [])
            setModalRelacionPage(data?.pagination?.page || page)
            setModalRelacionTotalPages(data?.pagination?.totalPages || 1)
            setModalRelacionTotal(data?.pagination?.total || 0)
        } catch (_) {
            toastr.error('No pude cargar las facturas')
        } finally {
            setModalRelacionLoading(false)
        }
    }

    const _openAddRelacionModal = () => {
        setModalRelacionSearch('')
        setModalRelacionPastYears(false)
        setModalRelacionPage(1)
        if (tipoDeComprobante === 'E') {
            setNewRelacionTipoRelacion(c_TipoRelacion[0])
        }
        // Pre-filter by the currently selected customer if any
        if (cliente?.value) {
            const clienteOption = clientes.find(c => c.value === cliente.value) || null
            setModalRelacionCliente(clienteOption)
            setIsAddRelacionModalOpen(true)
            _fetchFacturasTimbradas(1, cliente.value, '', false)
        } else {
            setModalRelacionCliente(null)
            setIsAddRelacionModalOpen(true)
            _fetchFacturasTimbradas(1, null, '', false)
        }
    }

    const _closeAddRelacionModal = () => {
        setIsAddRelacionModalOpen(false)
    }

    const _onModalRelacionSearchChange = (e) => {
        const val = e.target.value
        setModalRelacionSearch(val)
        clearTimeout(debounceRelacionRef.current)
        debounceRelacionRef.current = setTimeout(() => {
            _fetchFacturasTimbradas(1, modalRelacionCliente?.value || null, val, modalRelacionPastYears)
        }, 400)
    }

    const _onModalRelacionClienteChange = (option) => {
        setModalRelacionCliente(option)
        _fetchFacturasTimbradas(1, option?.value || null, modalRelacionSearch, modalRelacionPastYears)
    }

    const _onToggleModalRelacionPastYears = () => {
        const next = !modalRelacionPastYears
        setModalRelacionPastYears(next)
        _fetchFacturasTimbradas(1, modalRelacionCliente?.value || null, modalRelacionSearch, next)
    }

    const _commitRelacion = (factura, baseRelaciones) => {
        // Auto-fill FormaPago on a Nota de Crédito
        if (tipoDeComprobante === 'E' && factura.formaPago) {
            const matchedFormaPago = getFormaPagoOption(factura.formaPago)
            if (matchedFormaPago) setFormaPago(matchedFormaPago)
        }
        setCfdiRelacionados([...baseRelaciones, { uuid: factura.uuid, tipoRelacion: newRelacionTipoRelacion.value }])
        // If no customer is set on the form yet, set it from the invoice
        if (!cliente && factura.clienteId) {
            const match = clientes.find(c => c.value === factura.clienteId)
            if (match) setCliente(match)
        }
    }

    const _addRelacionFromRow = (factura) => {
        const uuid = factura.uuid
        if (!uuid) {
            toastr.error('La factura seleccionada no tiene UUID.')
            return
        }
        if (!newRelacionTipoRelacion?.value) {
            toastr.error('Selecciona el tipo de relación antes de agregar.')
            return
        }
        const isDuplicate = cfdiRelacionados.some(r => r.uuid === uuid && r.tipoRelacion === newRelacionTipoRelacion.value)
        if (isDuplicate) {
            toastr.warning('Este CFDI ya fue agregado con ese tipo de relación.')
            return
        }
        // Guard: different customer than the one already linked?
        const currentClienteId = cliente?.value || null
        const incomingClienteId = factura.clienteId || null
        if (currentClienteId && incomingClienteId && currentClienteId !== incomingClienteId && cfdiRelacionados.length > 0) {
            setPendingRelacion(factura)
            setIsConfirmRelacionModalOpen(true)
            return
        }
        // Modal stays open — don't close
        _commitRelacion(factura, cfdiRelacionados)
        toastr.success('CFDI relacionado agregado.')
    }

    const _confirmRelacionChangeCustomer = () => {
        if (!pendingRelacion) return
        _commitRelacion(pendingRelacion, [])
        // Update the form customer to the new one
        if (pendingRelacion.clienteId) {
            const match = clientes.find(c => c.value === pendingRelacion.clienteId)
            if (match) setCliente(match)
        }
        setPendingRelacion(null)
        setIsConfirmRelacionModalOpen(false)
    }

    const _cancelRelacionChangeCustomer = () => {
        setPendingRelacion(null)
        setIsConfirmRelacionModalOpen(false)
    }

    const _removeRelacion = (index) => {
        setCfdiRelacionados(cfdiRelacionados.filter((_, i) => i !== index))
    }

    const getUsoCFDIOption = (value) => head(usoCfdiValores.filter(a => a.value === value))
    const getMetodoPagoOption = (value) => head(MetodoPagoValores.filter(a => a.value === value))
    const getFormaPagoOption = (value) => head(formaPagoValores.filter(a => a.value === value))

    useEffect(() => {
        if (cliente?.rfc === 'XAXX010101000') {
            setShowInformacionGlobalForm(true)
        }

        if (cliente?.rfc !== 'XAXX010101000') {
            setShowInformacionGlobalForm(false)
        }
    }, [cliente])

    // When switching to Nota de Crédito force UsoCFDI G02 + MetodoPago PUE + show section
    useEffect(() => {
        if (tipoDeComprobante === 'E') {
            setUsoCFDI(getUsoCFDIOption('G02'))
            setMetodoPago(getMetodoPagoOption('PUE'))
            setShowCfdiRelacionadosForm(true)
            // Pre-select TipoRelacion 01 for the add-relation modal
            setNewRelacionTipoRelacion(c_TipoRelacion[0])
        }
        // When switching back to 'I' the section stays open if user already opened it
        // eslint-disable-next-line
    }, [tipoDeComprobante])

    useEffect(() => {
        (async () => {
            const [lugaresData, clientesData] = await Promise.all([
                fetchLugares(),
                fetchCustomers(),
                fetchServicios(),
                fetchCertificado(),
                fetchUnidades(),
                fetchClaves(),
                fetchAduanas(),
                fetchPatentes()
            ])

            if (id) {
                await fetchInvoiceDraft(id, clientesData, lugaresData)
                return
            }

            if (props.location?.state?.duplicatedFactura) {
                hydrateDuplicatedFactura(props.location.state.duplicatedFactura, clientesData, lugaresData)
            }

            if (props.location?.state?.cerrarSaldoPrefill) {
                hydrateCerrarSaldoPrefill(props.location.state.cerrarSaldoPrefill, clientesData)
            }
        })()

        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        _calculateTotales()

        // eslint-disable-next-line
    }, [lineItems])

    const fetchInvoiceDraft = async (id, clientesData, lugaresData) => {
        try {
            setLoading(true)
            const response = await ApiService.getInvoiceDraft(id)
            const { factura } = response.data

            setId(id)
            setCliente(head(clientesData.filter(a => a.id === factura.clienteId)))
            setUsoCFDI(getUsoCFDIOption(factura.usoCFDI))
            setMetodoPago(getMetodoPagoOption(factura.metodoPago))
            setFormaPago(getFormaPagoOption(factura.formaPago))
            setCondicionesPago(head(CondicionesDePagoValores.filter(a => a.value === factura.condicionesPago)))
            setPagada(head(StatusDePagoValores.filter(a => a.value === factura.pagada)))
            setLugarExpedicion(head(lugaresData.filter(a => a.value === factura.lugarExpedicion)))
            setMoneda(head(MonedaValores.filter(a => a.value === factura.moneda)))
            setTipoDeComprobante(factura.tipoComprobante || 'I')
            setScheduleStatus(factura.status)
            setScheduleErrorReason(factura.schedule?.errorReason || '')
            setCurrentSchedule(factura.schedule || null)
            setLineItems(factura.lineItems)

            const relacionados = Array.isArray(factura.cfdiRelacionados) ? factura.cfdiRelacionados : []
            setCfdiRelacionados(relacionados)
            if (relacionados.length > 0) {
                setShowCfdiRelacionadosForm(true)
            }
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const hydrateDuplicatedFactura = (duplicatedFactura, clientesData, lugaresData) => {
        const duplicatedFacturaState = getDuplicatedFacturaFormState({
            duplicatedFactura,
            clientes: clientesData,
            lugares: lugaresData
        })

        setId()
        setCliente(duplicatedFacturaState.cliente)
        setUsoCFDI(duplicatedFacturaState.usoCFDI || getUsoCFDIOption('G03'))
        setMetodoPago(duplicatedFacturaState.metodoPago || getMetodoPagoOption('PUE'))
        setFormaPago(duplicatedFacturaState.formaPago || getFormaPagoOption('03'))
        setCondicionesPago(duplicatedFacturaState.condicionesPago || head(CondicionesDePagoValores.filter(a => a.value === 'CONTADO')))
        setPagada(duplicatedFacturaState.pagada || head(StatusDePagoValores.filter(a => a.value === true)))
        if (duplicatedFacturaState.lugarExpedicion) {
            setLugarExpedicion(duplicatedFacturaState.lugarExpedicion)
        }
        setMoneda(duplicatedFacturaState.moneda || head(MonedaValores.filter(a => a.value === 'MXN')))
        setTipoCambio(duplicatedFacturaState.tipoCambio)
        setTipoDeComprobante(duplicatedFacturaState.tipoDeComprobante || 'I')
        setScheduleStatus('borrador')
        setScheduleErrorReason('')
        setCurrentSchedule(null)
        setReplacementContext(duplicatedFacturaState.replacementContext || null)
        setLineItems(duplicatedFacturaState.lineItems)
        if (duplicatedFacturaState.informacionGlobal) {
            setInformacionGlobal({
                Periodicidad: duplicatedFacturaState.informacionGlobal.Periodicidad || informacionGlobal.Periodicidad,
                Meses: duplicatedFacturaState.informacionGlobal.Meses || informacionGlobal.Meses,
                Año: duplicatedFacturaState.informacionGlobal.Año || informacionGlobal.Año
            })
        }
        setShowInformacionGlobalForm(duplicatedFacturaState.showInformacionGlobalForm)

        const relacionados = duplicatedFacturaState.cfdiRelacionados || []
        setCfdiRelacionados(relacionados)
        if (relacionados.length > 0) {
            setShowCfdiRelacionadosForm(true)
        }
    }

    const hydrateCerrarSaldoPrefill = (cerrarSaldoPrefill, clientesData) => {
        const state = buildCerrarSaldoPrefill(cerrarSaldoPrefill, clientesData)

        console.log(`CLIENTE`, state.cliente)

        setId()
        setCliente(state.cliente)
        setUsoCFDI(state.usoCFDI || getUsoCFDIOption('G02'))
        setMetodoPago(state.metodoPago || getMetodoPagoOption('PUE'))
        setFormaPago(state.formaPago)
        setTipoDeComprobante(state.tipoDeComprobante || 'E')
        setMoneda(state.moneda || head(MonedaValores.filter(a => a.value === 'MXN')))
        setTipoCambio(state.tipoCambio)
        setScheduleStatus('borrador')
        setScheduleErrorReason('')
        setCurrentSchedule(null)
        setLineItems(state.lineItems)
        setSourceFacturaId(state._sourceFacturaId || null)

        const relacionados = state.cfdiRelacionados || []
        setCfdiRelacionados(relacionados)
        if (relacionados.length > 0) {
            setShowCfdiRelacionadosForm(true)
        }
    }

    const _calculateTotales = () => {
        let subtotal = 0
        let traslados = []
        let retenciones = []
        let descuentos = 0
        let total = 0

        // eslint-disable-next-line
        lineItems.map((item) => {
            const descuento = parseFloat(item.Descuento) || 0
            const importe = parseFloat(item.ValorUnitario * item.Cantidad)

            subtotal += +importe - +descuento

            let tit = 0
            let tir = 0
            if (!isEmpty(item.Impuestos)) {
                if (!isEmpty(item.Impuestos.Traslados)) {
                    // eslint-disable-next-line
                    item.Impuestos.Traslados.map((i) => {
                        let label
                        let flag = false
                        if (i.Impuesto === '002') { label = 'IVA' }
                        if (i.Impuesto === '001') { label = 'ISR' }

                        // eslint-disable-next-line
                        traslados.find((t) => {
                            if (t.label === `${label} Trasladado (${i.TasaOCuota * 100}%)`) {
                                t.value += parseFloat(i.Importe) || 0
                                flag = true
                            }
                        })

                        if (!flag) {
                            traslados.push({
                                label: `${label} Trasladado (${i.TasaOCuota * 100}%)`,
                                value: parseFloat(i.Importe) || 0
                            })
                        }

                        tit += parseFloat(i.Importe) || 0
                    })
                }

                if (!isEmpty(item.Impuestos.Retenciones)) {
                    // eslint-disable-next-line
                    item.Impuestos.Retenciones.map((i) => {
                        let label
                        let flag = false
                        if (i.Impuesto === '002') { label = 'IVA' }
                        if (i.Impuesto === '001') { label = 'ISR' }

                        // eslint-disable-next-line
                        retenciones.find((r) => {
                            if (r.label === `${label} Retenido (${i.TasaOCuota * 100}%)`) {
                                r.value += parseFloat(i.Importe) || 0
                                flag = true
                            }
                        })

                        if (!flag) {
                            retenciones.push({
                                label: `${label} Retenido (${i.TasaOCuota * 100}%)`,
                                value: parseFloat(i.Importe) || 0
                            })
                        }

                        tir += parseFloat(i.Importe) || 0
                    })
                }
            }

            total += +importe - +descuento - +tir + +tit
            descuentos += +descuento
        })

        setTotales({
            subtotal,
            traslados,
            retenciones,
            descuentos,
            total
        })
    }

    const fetchLugares = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getLugares()
            let data = []

            // eslint-disable-next-line
            response.data.data.map((item) => {
                data.push({
                    value: item.cp,
                    label: item.nombre,
                })
            })

            setLugares(data)
            setLugarExpedicion(data[0])

            return data
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchCustomers = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getCustomers()
            let data = []
            // eslint-disable-next-line
            response.data.data.map((item) => {
                data.push({
                    id: item._id,
                    value: item._id,
                    label: item.razonSocial,
                    razonSocial: item.razonSocial,
                    rfc: item.rfc,
                    email: item.email || '',
                    residenciaFiscal: item.residenciaFiscal || false,
                    domicilioFiscal: item.cp,
                    regimenFiscal: item.regimenFiscal
                })
            })

            setClientes(data)

            return data
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchServicios = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getServices()
            let data = []

            // eslint-disable-next-line
            response.data.data.map((item) => {
                data.push({
                    value: item._id,
                    label: item.descripcion
                })
            })

            setServicios(data)
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchCertificado = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getCertificado()

            if (!response.data.success) {
                toastr.error(`No pude obtener el certificado, asegúrate que si lo tienes agregado.`, 'Falta Certificado')

                return
            }

            setCertificado(response.data.certificado.noCertificado)
        } catch (error) {
            toastr.error(`No pude obtener el certificado`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchUnidades = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getUnidades()
            let data = []

            // eslint-disable-next-line
            response.data.data.map((item) => {
                return data.push({
                    value: item.clave,
                    label: `(${item.clave}) ${item.descripcion}`
                })
            })

            setUnidades(data)
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchClaves = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getClaves()
            let data = []

            // eslint-disable-next-line
            response.data.data.map((item) => {
                return data.push({
                    value: item.clave,
                    label: `(${item.clave}) ${item.descripcion}`
                })
            })

            setClaves(data)
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchAduanas = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getAduanas()
            const { data } = response.data

            setAduanas(data.map((item) => ({
                value: item.clave,
                label: `(${item.clave}) ${item.descripcion || ''}`.trim(),
                descripcion: item.descripcion || ''
            })))
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchPatentes = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getPatentes()
            const { data } = response.data

            setPatentes(data.map((item) => ({
                value: item.clave,
                label: `(${item.clave}) ${item.descripcion || ''}`.trim(),
                descripcion: item.descripcion || ''
            })))
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const _selectCustomer = async (customer) => {
        const selectedCustomer = head(clientes.filter(i => i.id === customer.value))

        setCliente(selectedCustomer)

        if (selectedCustomer?.rfc === 'XAXX010101000') {
            const publicoGeneralUso = getUsoCFDIOption('S01')

            if (publicoGeneralUso) {
                setUsoCFDI(publicoGeneralUso)
            }
        }
    }

    const _selectMetodoPago = (value) => {
        setMetodoPago(value)

        if (value?.value === 'PPD') {
            const formaPagoPorDefinir = getFormaPagoOption('99')

            if (formaPagoPorDefinir) {
                setFormaPago(formaPagoPorDefinir)
                setPagada({
                    label: 'Por cobrar',
                    value: false
                })
            }
        }
    }

    const selectService = async (service) => {
        if (service.value === '') { return false }

        setLoading(true)
        const id = service.value

        try {
            const record = await ApiService.getService(id)
            const { data } = record.data

            setTempItem({
                claveProdServ: {
                    label: data.claveProdServ,
                    value: data.claveProdServ
                },
                descripcion: data.descripcion,
                claveUnidad: {
                    value: data.claveUnidad,
                    label: data.claveUnidad
                },
                noIdentificacion: data.noIdentificacion || '',
                cantidad: 1,
                impuestosTrasladados: tempItem.impuestosTrasladados,
                retenciones: tempItem.retenciones,
                valorUnitario: data.valorUnitario,
                importe: data.valorUnitario,
                descuento: 0,
                ObjetoImp: ObjetoImpCatalogo.find(o => o.value === data.ObjetoImp)
            })
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const searchForProdServInSAT = async (query) => {
        try {
            setLoading(true)
            const response = await ApiService.searchForCPSInSAT(query)
            const { data } = response.data

            setAutosuggest(data)
        } catch (error) {
            toastr.error(`No pude buscar en el catálogo SAT`)
        } finally {
            setLoading(false)
        }
    }

    const _addClaveProdServ = async (selected) => {
        if (selected.length > 0) {
            const item = selected[0]

            try {
                setLoading(true)
                const response = await ApiService.createCPS({
                    clave: item.clave,
                    descripcion: item.descripcion
                })

                toastr.success(response.data.message, '¡Éxito!')

                fetchClaves()
                setTempItem({
                    ...tempItem,
                    claveProdServ: {
                        label: item.descripcion,
                        value: item.clave
                    }
                })

                setIsAddClaveModalOpen(false)
            } catch (error) {
                toastr.error(`No pude agregar la clave de producto o servicio`)
            } finally {
                setLoading(false)
            }
        }
    }

    const searchForUnidadInSAT = async (query) => {
        try {
            setLoading(true)
            const response = await ApiService.searchForUnidadInSAT(query)
            const { data } = response.data

            setAutosuggest(data)
        } catch (error) {
            toastr.error(`No pude buscar en el catálogo SAT`)
        } finally {
            setLoading(false)
        }
    }

    const _addClaveUnidad = async (selected) => {
        if (selected.length > 0) {
            const item = selected[0]

            try {
                setLoading(true)
                const response = await ApiService.createUnidad({
                    clave: item.clave,
                    descripcion: item.descripcion
                })

                toastr.success(response.data.message, '¡Éxito!')

                fetchUnidades()
                setTempItem({
                    ...tempItem,
                    claveUnidad: {
                        label: item.descripcion,
                        value: item.clave
                    }
                })

                setIsAddClaveUnidadModalOpen(false)
            } catch (error) {
                toastr.error(`No pude agregar la clave de unidad`)
            } finally {
                setLoading(false)
            }
        }
    }

    const searchForAduanaInSAT = async (query) => {
        try {
            setLoading(true)
            const response = await ApiService.searchForAduanaInSAT(query)
            const { data } = response.data

            setAduanaAutosuggest(data)
        } catch (error) {
            toastr.error(`No pude buscar en el catalogo maestro de aduanas`)
        } finally {
            setLoading(false)
        }
    }

    const searchForPatenteInSAT = async (query) => {
        try {
            setLoading(true)
            const response = await ApiService.searchForPatenteInSAT(query)
            const { data } = response.data

            setPatenteAutosuggest(data)
        } catch (error) {
            toastr.error(`No pude buscar en el catalogo maestro de patentes`)
        } finally {
            setLoading(false)
        }
    }

    const _addAduanaRecord = async (selected) => {
        if (!selected || selected.length < 1) {
            return
        }

        const item = selected[0]

        try {
            setLoading(true)
            const payload = {
                clave: item.clave,
                descripcion: item.descripcion
            }
            const response = await ApiService.createAduana(payload)

            toastr.success(response.data.message, '¡Éxito!')
            await fetchAduanas()
            setAduanaAutosuggest([])
            closeAddAduanaModal()
        } catch (error) {
            toastr.error(`No pude agregar la aduana`)
        } finally {
            setLoading(false)
        }
    }

    const _addPatenteRecord = async (selected) => {
        if (!selected || selected.length < 1) {
            return
        }

        const item = selected[0]

        try {
            setLoading(true)
            const payload = {
                clave: item.clave,
                descripcion: item.descripcion
            }
            const response = await ApiService.createPatente(payload)

            toastr.success(response.data.message, '¡Éxito!')
            await fetchPatentes()
            setPatenteAutosuggest([])
            closeAddPatenteModal()
        } catch (error) {
            toastr.error(`No pude agregar la patente`)
        } finally {
            setLoading(false)
        }
    }

    const getCatalogOption = (options, value) => {
        if (!value) {
            return ''
        }

        const matchedOption = options.find((option) => option.value === value)

        if (matchedOption) {
            return matchedOption
        }

        return {
            value,
            label: value
        }
    }

    const getIvaExentoIndex = () => {
        const matchedIndex = impuestos.trasladados.findIndex((option) => {
            return option.value?.some((tax) => tax.tipoFactor === IVA_EXENTO_TIPO_FACTOR)
        })

        return matchedIndex >= 0 ? matchedIndex : 0
    }

    const getTaxIndex = (taxOptions, taxes = [], emptyValue = 0) => {
        if (!taxes || taxes.length < 1) {
            return emptyValue
        }

        const matchedIndex = taxOptions.findIndex((option) => {
            if (!option.value || option.value.length !== taxes.length) {
                return false
            }

            return option.value.every((tax, index) => {
                const selectedTax = taxes[index]

                if (tax.tipoFactor === IVA_EXENTO_TIPO_FACTOR) {
                    return (
                        tax.code === selectedTax.Impuesto &&
                        selectedTax.TipoFactor === IVA_EXENTO_TIPO_FACTOR
                    )
                }

                return (
                    tax.code === selectedTax.Impuesto &&
                    tax.tasaLabel === selectedTax.TasaOCuota
                )
            })
        })

        return matchedIndex >= 0 ? matchedIndex : emptyValue
    }

    const mapLineItemToTempItem = (item) => {
        const itemImporte = parseFloat(item.Importe) || 0
        const itemDescuento = parseFloat(item.Descuento) || 0
        const discountPercentage = itemImporte > 0
            ? numberFormat((itemDescuento / itemImporte) * 100, 6, '.', '')
            : 0

        return {
            claveProdServ: getCatalogOption(claves, item.ClaveProdServ),
            descripcion: item.Descripcion || '',
            claveUnidad: getCatalogOption(unidades, item.ClaveUnidad),
            noIdentificacion: item.NoIdentificacion || '',
            cantidad: item.Cantidad || 1,
            valorUnitario: item.ValorUnitario || 0,
            importe: itemImporte,
            descuento: discountPercentage,
            impuestosTrasladados: getTaxIndex(impuestos.trasladados, item.Impuestos?.Traslados, 0),
            retenciones: getTaxIndex(impuestos.retenciones, item.Impuestos?.Retenciones, 0),
            total: 0,
            InformacionAduanera: item.InformacionAduanera || '',
            CuentaPredial: item.CuentaPredial || '',
            ObjetoImp: ObjetoImpCatalogo.find(o => o.value === item.ObjetoImp) || getDefaultTempItem().ObjetoImp
        }
    }

    const buildLineItemFromTempItem = (currentTempItem) => {
        const descuento = currentTempItem.descuento / 100
        const cantidad = parseFloat(currentTempItem.cantidad) || 0
        const valorUnitario = parseFloat(currentTempItem.valorUnitario) || 0
        const retencionesIndex = Number(currentTempItem.retenciones) || 0
        const hasRetenciones = retencionesIndex !== 0
        const shouldUseExentoForRetencion = currentTempItem.ObjetoImp.value === OBJETO_IMP_NO_OBJETO && hasRetenciones
        const impuestosTrasladadosIndex = shouldUseExentoForRetencion
            ? getIvaExentoIndex()
            : Number(currentTempItem.impuestosTrasladados) || 0
        const objetoImp = shouldUseExentoForRetencion
            ? OBJETO_IMP_OBJETO
            : currentTempItem.ObjetoImp.value
        const importe = valorUnitario * cantidad
        const importeDescontado = importe * descuento
        const subtotal = importe - importeDescontado

        let item = {
            "ClaveProdServ": currentTempItem.claveProdServ.value,
            "Descripcion": currentTempItem.descripcion,
            "ClaveUnidad": currentTempItem.claveUnidad.value,
            "Cantidad": cantidad,
            "ValorUnitario": numberFormat(valorUnitario, 2, '.', ''),
            "Importe": numberFormat(importe, 2, '.', ''),
            "Descuento": importeDescontado,
            "ObjetoImp": objetoImp
        }

        if (currentTempItem.noIdentificacion.trim() !== '') {
            item.NoIdentificacion = currentTempItem.noIdentificacion.trim()
        }

        if (objetoImp === OBJETO_IMP_OBJETO) {
            item.Impuestos = {}
            item.Impuestos.Traslados = []

            impuestos.trasladados[impuestosTrasladadosIndex].value.map((i) => {
                const trasladoImporte = subtotal * i.tasa

                if (i.tipoFactor === IVA_EXENTO_TIPO_FACTOR) {
                    return item.Impuestos.Traslados.push({
                        "Base": numberFormat(subtotal, 2, '.', ''),
                        "Impuesto": i.code,
                        "TipoFactor": IVA_EXENTO_TIPO_FACTOR
                    })
                }

                return item.Impuestos.Traslados.push({
                    "Base": numberFormat(subtotal, 2, '.', ''),
                    "Impuesto": i.code,
                    "TipoFactor": "Tasa",
                    "TasaOCuota": i.tasaLabel,
                    "Tasa": i.tasa,
                    "Importe": numberFormat(trasladoImporte, 2, '.', '')
                })
            })
        }

        if (objetoImp === OBJETO_IMP_OBJETO && hasRetenciones) {
            if (isEmpty(item.Impuestos)) { item.Impuestos = {} }
            item.Impuestos.Retenciones = []

            impuestos.retenciones[retencionesIndex].value.map((i) => {
                const retencionImporte = subtotal * i.tasa

                return item.Impuestos.Retenciones.push({
                    "Base": numberFormat(subtotal, 2, '.', ''),
                    "Impuesto": i.code,
                    "TipoFactor": "Tasa",
                    "TasaOCuota": i.tasaLabel,
                    "Tasa": i.tasa,
                    "Importe": numberFormat(retencionImporte, 2, '.', '')
                })
            })
        }

        if (currentTempItem.CuentaPredial !== '') {
            item = {
                ...item,
                "CuentaPredial": currentTempItem.CuentaPredial
            }
        }

        if (currentTempItem.InformacionAduanera !== '') {
            item = {
                ...item,
                "InformacionAduanera": currentTempItem.InformacionAduanera
            }
        }

        return item
    }

    const isValidPedimento = (pedimento = '') => {
        if (!pedimento) {
            return true
        }

        if (!PEDIMENTO_REGEX.test(pedimento)) {
            return false
        }

        const [validationYearValue, , , progressiveNumber] = pedimento.split(' ')
        const validationYear = Number(validationYearValue)
        const currentYear = Number(Moment().format('YY'))
        const expectedProgressivePrefix = validationYearValue.slice(-1)

        return validationYear <= currentYear && progressiveNumber.startsWith(expectedProgressivePrefix)
    }

    const _addLineItem = () => {
        if (!_validateConcept(tempItem)) {
            toastr.error(`No olvides escribir los datos del concepto que deseas facturar`)

            return false
        }

        setLoading(true)
        const item = buildLineItemFromTempItem(tempItem)

        setLineItems([
            ...lineItems,
            item
        ])

        setTempItem(getDefaultTempItem())

        setServicio('')
        setLoading(false)
    }

    const _validateConcept = (item = tempItem) => {
        if (item.claveProdServ === '') { return false }
        if (item.claveUnidad === '') { return false }
        if (item.descripcion === '') { return false }
        if (item.cantidad < 1) { return false }
        if (item.valorUnitario < 0.0000000000001) { return false }
        if (!isValidPedimento(item.InformacionAduanera)) {
            toastr.error('El No. Pedimento debe tener el formato 12 34 5678 9012345 y el consecutivo debe iniciar con el ultimo digito del año de validacion.', 'Pedimento invalido')
            return false
        }

        return true
    }

    const _removeItem = (index) => {
        let items = lineItems.filter((v, i) => {
            return i !== index
        })

        setLineItems(items)
    }

    const _openEditLineItemModal = (index) => {
        setEditingLineItemIndex(index)
        setEditTempItem(mapLineItemToTempItem(lineItems[index]))
        setIsEditLineItemModalOpen(true)
    }

    const _updateLineItem = () => {
        if (!_validateConcept(editTempItem)) {
            toastr.error(`No olvides escribir los datos del concepto que deseas facturar`)

            return false
        }

        const items = [...lineItems]
        items[editingLineItemIndex] = buildLineItemFromTempItem(editTempItem)
        setLineItems(items)
        closeEditLineItemModal()
    }

    const _saveAsDraft = async (e, options = {}) => {
        try {
            if (e?.preventDefault) {
                e.preventDefault()
            }

            if (!_validateForm()) {
                toastr.error(`No olvides escribir los datos de la factura`)

                return { success: false }
            }

            setLoading(true)
            const plantilla = generatePlantilla()
            const response = await ApiService.saveAsDraft({
                facturaId: _id,
                clienteId: cliente.id,
                pagada: pagada.value,
                tipoDeComprobante,
                plantilla,
                cfdiRelacionados
            })

            if (!response.data.success) {
                toastr.error(response.data.message, 'Error')

                return { success: false }
            }

            setId(response.data.facturaId)
            if (!options.preserveStatus) {
                setScheduleStatus('borrador')
                setCurrentSchedule(null)
            }

            setScheduleErrorReason('')

            if (!options.skipSuccessToast) {
                toastr.success(response.data.message, '¡Éxito!')
            }

            return {
                success: true,
                facturaId: response.data.facturaId
            }
        } catch (error) {
            const { response } = error
            if (response && response.data) {
                const { message, code } = response.data

                if (!message) {
                    toastr.error('Contáctanos si el problema persiste', `No pudimos conectarnos con el servidor, revisa que tengas conexión`)
                    return { success: false }
                }

                toastr.error(`[${code}] ${message}`, `Tenemos algo que hablar`)

                return { success: false }
            }

            toastr.error('Contáctanos si el problema persiste', `No pudimos conectarnos con el servidor, revisa que tengas conexión`)
            console.error('Error details:', error)
            return { success: false }
        } finally {
            setLoading(false)
        }
    }

    const _openProgramarFacturaModal = async (e) => {
        if (e?.preventDefault) {
            e.preventDefault()
        }

        const draftResult = await _saveAsDraft(e, {
            skipSuccessToast: true,
            preserveStatus: true
        })

        if (!draftResult?.success || !draftResult?.facturaId) {
            return
        }

        setFacturaIdToSchedule(draftResult.facturaId)
        setProgramarFacturaModalOpen(true)
    }

    const _desprogramarFactura = async () => {
        if (!_id) {
            toastr.error('No se encontró el ID de la factura')
            return
        }

        try {
            setLoading(true)
            const response = await ApiService.desprogramarFactura(_id)

            if (!response.data.success) {
                toastr.error(response.data.message, 'Error')
                return
            }

            toastr.success(response.data.message, '¡Éxito!')
            setScheduleStatus('borrador')
            setCurrentSchedule(null)
        } catch (error) {
            const { response } = error
            if (response && response.data) {
                toastr.error(response.data.message, 'Error')
                return
            }
            toastr.error('Contáctanos si el problema persiste', 'No pudimos conectarnos con el servidor')
        } finally {
            setLoading(false)
        }
    }

    const handleSubmit = async (e) => {
        let stampRequest = null
        try {
            e.preventDefault()
            if (!_validateForm()) {
                toastr.error(`No olvides escribir los datos de la factura`)

                return false
            }

            setLoading(true)
            const plantilla = generatePlantilla()
            stampRequest = {
                facturaId: _id,
                clienteId: cliente.id,
                tipoDeComprobante,
                plantilla,
                pagada: pagada.value,
                cfdiRelacionados,
                _sourceFacturaId,
                replacementContext
            }
            const response = await ApiService.timbrarFactura(stampRequest)

            if (!response.data.success) {
                toastr.error(response.data.message, 'Error')

                return false
            }

            toastr.success(response.data.message, '¡Éxito!')

            props.history.push('/facturas')
        } catch (error) {
            const { response } = error

            if (response && response.data) {
                const { message, code } = response.data

                if (code === 'NO_CREDITS' && stampRequest) {
                    setPendingStampRequest(stampRequest)
                    if (window.analytics) {
                        window.analytics.track('Paywall requerido', { source: 'standard_invoice' })
                    }
                    return
                }

                if (!message) {
                    toastr.error('Contáctanos si el problema persiste', `No pudimos conectarnos con el servidor, revisa que tengas conexión`)
                    return
                }

                toastr.error(`[${code}] ${message}`, `Tenemos algo que hablar`)
            }

            toastr.error('Contáctanos si el problema persiste', `No pudimos conectarnos con el servidor, revisa que tengas conexión`)
            console.error('Error details:', error)
        } finally {
            setLoading(false)
        }
    }

    const retryStampAfterPayment = async () => {
        const stampRequest = pendingStampRequest
        if (!stampRequest) { return }

        setPendingStampRequest(null)
        setLoading(true)
        try {
            const response = await ApiService.timbrarFactura(stampRequest)
            if (!response.data.success) {
                toastr.error(response.data.message, 'Error')
                return
            }

            if (window.analytics) {
                window.analytics.track('Primera factura timbrada después de pago')
            }
            toastr.success(response.data.message, '¡Éxito!')
            props.history.push('/facturas')
        } catch (error) {
            toastr.error(error.response?.data?.message || 'No pudimos timbrar la factura después del pago. Intenta nuevamente.')
        } finally {
            setLoading(false)
        }
    }

    const _validateForm = () => {
        if (!cliente) { return false }
        if (lugarExpedicion.length < 1) { return false }
        if (lineItems.length < 1) { return false }
        if (cliente.domicilioFiscal === '') {
            toastr.info(`Debes actualizar los datos fiscales de tu cliente`)

            return false
        }

        if (tipoDeComprobante === 'E') {
            const hasRelacion01 = cfdiRelacionados.some(r => r.tipoRelacion === '01')
            if (!hasRelacion01) {
                toastr.error('Una Nota de Crédito requiere al menos un CFDI relacionado con TipoRelacion 01.')
                return false
            }
        }

        return true
    }

    // const formatTraslados = (impuestos, type = 'traslados') => {
    //     return {
    //         ...traslados,
    //         Traslados: traslados.Traslados.map(traslado => ({
    //             ...traslado,
    //             Base: parseFloat(numberFormat(traslado.Base, 2, '.', '')),
    //             Importe: parseFloat(numberFormat(traslado.Importe, 2, '.', ''))
    //         }))
    //     }
    // }

    const generateInvoicePreview = async () => {
        try {
            const plantilla = generatePlantilla()

            if (!plantilla) {
                toastr.info(`Agrega conceptos a la factura para generar la vista previa`)

                return
            }

            setLoading(true)
            const response = await ApiService.getInvoicePreview({ plantilla })

            if (response.headers['content-type'] !== 'application/pdf') {
                throw new Error('Failed to generate PDF')
            }

            const blob = response.data
            const blobUrl = URL.createObjectURL(blob)

            setPreviewPDF(blobUrl)
            setIsModalPreviewOpen(true)
        } catch (error) {
            console.log(error)
            toastr.error('No se pudo generar la previsualización de la factura')
        } finally {
            setLoading(false)
        }
    }

    const generatePlantilla = () => {
        if (!cliente || lineItems.length < 1) {
            return false
        }

        const { profile } = props
        let plantilla = {
            "Version": '4.0',
            "NoCertificado": certificado,
            "Folio": '',
            "Fecha": '',
            "FormaPago": formaPago.value,
            "CondicionesDePago": condicionesPago.value,
            "SubTotal": numberFormat(totales.subtotal + totales.descuentos, 2, '.', ''),
            "Total": numberFormat(totales.total, 2, '.', ''),
            "Moneda": moneda.value,
            "TipoDeComprobante": tipoDeComprobante,
            "MetodoPago": metodoPago.value,
            "LugarExpedicion": lugarExpedicion.value,
            "Exportacion": "01", // 01 No Aplica @todo: investigar las demás opciones.
            "Emisor": {
                "Rfc": profile.empresa.rfc.toUpperCase(),
                "Nombre": profile.empresa.razonSocial.toUpperCase(),
                "RegimenFiscal": profile.empresa.regimenFiscal
            },
            "Receptor": {
                "Rfc": cliente.rfc.toUpperCase(),
                "Nombre": cliente.razonSocial.toUpperCase(),
                "UsoCFDI": usoCFDI.value,
                "Email": cliente.email,
                "DomicilioFiscalReceptor": cliente.domicilioFiscal,
                "RegimenFiscalReceptor": cliente.regimenFiscal
            },
            "Conceptos": lineItems,
            "Impuestos": {}
        }

        if (showInformacionGlobalForm) {
            plantilla.InformacionGlobal = {
                Periodicidad: informacionGlobal.Periodicidad.value,
                Meses: informacionGlobal.Meses.value,
                Año: informacionGlobal.Año.value,
            }
        }

        if (moneda.value !== 'MXN' && moneda.value !== 'XXX') {
            plantilla.TipoCambio = tipoCambio
        }

        let traslados = []
        let retenciones = []
        let tit = 0
        let tir = 0
        let hasNonExentoTraslados = false

        // eslint-disable-next-line
        lineItems.map((item) => {
            if (!isEmpty(item.Impuestos)) {
                if (!isEmpty(item.Impuestos.Traslados)) {
                    item.Impuestos.Traslados.reduce((tax, { Base, TasaOCuota, Importe, Impuesto, TipoFactor }) => {
                        const taxKey = TipoFactor === IVA_EXENTO_TIPO_FACTOR
                            ? `${Impuesto}-${TipoFactor}`
                            : `${Impuesto}-${TipoFactor}-${TasaOCuota}`
                        const baseNum = parseFloat(Base) || 0
                        const importeNum = parseFloat(Importe) || 0
                        traslados[taxKey] = traslados[taxKey] || { Base: 0, TasaOCuota, Importe: 0, Impuesto, TipoFactor }
                        traslados[taxKey].Base += baseNum

                        if (TipoFactor !== IVA_EXENTO_TIPO_FACTOR) {
                            traslados[taxKey].Importe += importeNum
                            hasNonExentoTraslados = true
                        }

                        tax = traslados[taxKey]
                        tit += importeNum

                        return tax
                    }, {})
                }

                if (!isEmpty(item.Impuestos.Retenciones)) {
                    item.Impuestos.Retenciones.reduce((tax, { TasaOCuota, Importe, Impuesto, TipoFactor }) => {
                        const importeNum = parseFloat(Importe) || 0
                        retenciones[TasaOCuota] = retenciones[TasaOCuota] || { TasaOCuota, Importe: 0, Impuesto, TipoFactor }
                        retenciones[TasaOCuota].Importe += importeNum
                        tax = retenciones[TasaOCuota]
                        tir += importeNum

                        return tax
                    }, {})
                }
            }
        })

        traslados = Object.values(traslados).map(t => {
            const traslado = {
                Base: parseFloat(numberFormat(t.Base, 2, '.', '')),
                Impuesto: t.Impuesto,
                TipoFactor: t.TipoFactor
            }

            if (t.TipoFactor !== IVA_EXENTO_TIPO_FACTOR) {
                traslado.TasaOCuota = t.TasaOCuota
                traslado.Importe = parseFloat(numberFormat(t.Importe, 2, '.', ''))
            }

            return traslado
        })

        if (hasNonExentoTraslados || tit > 0) {
            plantilla.Impuestos.TotalImpuestosTrasladados = numberFormat(tit, 2, '.', '')
        }

        if (traslados.length > 0) {
            plantilla.Impuestos.Traslados = traslados
        }

        if (tir > 0) {
            retenciones = Object.values(retenciones).map(r => ({
                ...r,
                Importe: parseFloat(numberFormat(r.Importe, 2, '.', ''))
            }))

            plantilla.Impuestos.TotalImpuestosRetenidos = numberFormat(tir, 2, '.', '')
            plantilla.Impuestos.Retenciones = retenciones
        }

        if (cliente.residenciaFiscal) {
            plantilla.Receptor.ResidenciaFiscal = cliente.residenciaFiscal
        }

        if (totales.descuentos > 0) {
            plantilla.Descuento = numberFormat(totales.descuentos, 2, '.', '')
        }

        if (cfdiRelacionados.length > 0) {
            plantilla.CfdiRelacionados = cfdiRelacionados
        }

        return plantilla
    }

    return (
        <React.Fragment>
            <Form id="invoice-create" method="POST" onSubmit={handleSubmit}>
                <Row>
                    <Col sm="12" xs="12">
                        <Card style={{ textAlign: 'right' }}>
                            <CardBody>
                                <Row className="align-items-center mb-3" style={{ textAlign: 'left' }}>
                                    <Col xs={12} md={8}>
                                        <Label className="d-block mb-2">
                                            Tipo de comprobante
                                        </Label>
                                        <div className="d-flex align-items-center flex-wrap">
                                            <ButtonGroup>
                                                <Button
                                                    variant={tipoDeComprobante === 'I' ? 'success' : 'outline-secondary'}
                                                    onClick={() => setTipoDeComprobante('I')}
                                                >
                                                    Factura
                                                </Button>
                                                <Button
                                                    variant={tipoDeComprobante === 'E' ? 'success' : 'outline-secondary'}
                                                    onClick={() => setTipoDeComprobante('E')}
                                                >
                                                    Nota de crédito
                                                </Button>
                                            </ButtonGroup>
                                            {tipoDeComprobante === 'E' && (
                                                <Badge color="warning" pill className="ml-2">
                                                    Nota de crédito
                                                </Badge>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                {scheduleStatus === 'programada' || scheduleStatus === 'fallida' ? (
                                    <ButtonGroup>
                                        <Dropdown as={ButtonGroup}>
                                            <Button data-testid="invoice-preview" color="secondary" variant='secondary' onClick={generateInvoicePreview}><i className={`fa fa-qrcode`}></i> Previsualizar Factura</Button>
                                            <Button color="primary" variant="success" onClick={_openProgramarFacturaModal}><i className={`fa fa-clock`}></i> Actualizar programación</Button>
                                            <Dropdown.Toggle split variant="success" className='dropdown-toggle-icon' id="dropdown-custom-2" />
                                            <Dropdown.Menu id="bg-nested-dropdown">
                                                <Dropdown.Item eventKey="1" onClick={handleSubmit}>Timbrar ahora</Dropdown.Item>
                                                <Dropdown.Item eventKey="2" onClick={_desprogramarFactura}>Cancelar programación</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </ButtonGroup>
                                ) : (
                                    <ButtonGroup>
                                        <Dropdown as={ButtonGroup}>
                                            <Button data-testid="invoice-preview" color="secondary" variant='secondary' onClick={generateInvoicePreview}><i className={`fa fa-qrcode`}></i> Previsualizar Factura</Button>
                                            <Button data-testid="invoice-stamp" type="submit" color="primary" variant="success"><i className={`fa fa-stamp`}></i> Timbrar Factura</Button>
                                            <Dropdown.Toggle data-testid="invoice-more-actions" split variant="success" className='dropdown-toggle-icon' id="dropdown-custom-2" />
                                            <Dropdown.Menu id="bg-nested-dropdown">
                                                <Dropdown.Item data-testid="invoice-save-draft" eventKey="1" onClick={_saveAsDraft}>Guardar como borrador</Dropdown.Item>
                                                <Dropdown.Item eventKey="3" onClick={_openProgramarFacturaModal}>Programar Factura</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </ButtonGroup>
                                )}
                            </CardBody>
                        </Card>

                        {scheduleStatus === 'programada' && (
                            <Alert color="warning">
                                Esta factura está programada. Si guardas cambios o timbras manualmente, continuarás desde este documento.
                            </Alert>
                        )}

                        {replacementContext?.type === 'pue-expired-ppd' && (
                            <Alert color="warning">
                                Esta factura sustituye a la PUE {replacementContext.sourceFolio || replacementContext.sourceUuid || ''} porque el pago ocurrió fuera del mes de emisión. Revisa y timbra esta factura PPD/99; al terminar, Timbrat intentará cancelar automáticamente la PUE original con motivo 01 usando el nuevo UUID como sustitución.
                            </Alert>
                        )}

                        {scheduleStatus === 'fallida' && (
                            <Alert color="danger">
                                <strong>La factura programada falló.</strong> {scheduleErrorReason || 'Revisa los datos antes de volver a intentarlo.'}
                            </Alert>
                        )}

                        <Card>
                            <Row>
                                <Col xs={12} sm={12} md={6} lg={3}>
                                    <FormGroup>
                                        <Label htmlFor="metodoPago">
                                            Cliente
                                        </Label>

                                        <Select
                                            data-testid="invoice-customer"
                                            value={cliente}
                                            placeholder={`Selecciona un cliente`}
                                            onChange={(value) => {
                                                _selectCustomer(value)
                                            }}
                                            options={clientes}
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={3}>
                                    <FormGroup>
                                        <Label htmlFor="usoCFDI">
                                            Uso del CFDI
                                        </Label>

                                        <Select
                                            value={usoCFDI}
                                            placeholder={`Selecciona un uso del CFDi`}
                                            onChange={(value) => {
                                                setUsoCFDI(value)
                                            }}
                                            options={usoCfdiValores}
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={3}>
                                    <FormGroup>
                                        <Label htmlFor="metodoPago">
                                            Método de Pago
                                        </Label>

                                        <Select
                                            value={metodoPago}
                                            onChange={(value) => {
                                                _selectMetodoPago(value)
                                            }}
                                            options={MetodoPagoValores}
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={3}>
                                    <FormGroup>
                                        <Label htmlFor="formaPago">
                                            Forma de Pago
                                        </Label>

                                        <Select
                                            value={formaPago}
                                            placeholder={`Selecciona una forma de pago`}
                                            onChange={(value) => {
                                                setFormaPago(value)
                                            }}
                                            options={formaPagoValores}
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} sm={12} md={6} lg={3}>
                                    <FormGroup>
                                        <Label htmlFor="condicionesPago">
                                            Condiciones de Pago
                                        </Label>

                                        <Select
                                            value={condicionesPago}
                                            placeholder={`Selecciona las condiciones de pago`}
                                            onChange={(value) => {
                                                setCondicionesPago(value)
                                            }}
                                            options={CondicionesDePagoValores}
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={3}>
                                    <FormGroup>
                                        <Label htmlFor="pagada">
                                            Status de Pago
                                        </Label>

                                        <Select
                                            value={pagada}
                                            onChange={(value) => {
                                                setPagada(value)
                                            }}
                                            options={metodoPago?.value === 'PPD'
                                                ? StatusDePagoValores.filter(option => option.value === false)
                                                : StatusDePagoValores}
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={3}>
                                    <FormGroup>
                                        <Label htmlFor="lugarExpedicion">
                                            Lugar de Expedición
                                        </Label>

                                        <Select
                                            data-testid="invoice-location"
                                            value={lugarExpedicion}
                                            placeholder={`Selecciona un lugar de expedición`}
                                            onChange={(value) => {
                                                setLugarExpedicion(value)
                                            }}
                                            options={lugares}
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={3}>
                                    <FormGroup>
                                        <Label htmlFor="moneda">
                                            Moneda
                                        </Label>

                                        <Select
                                            value={moneda}
                                            onChange={(value) => {
                                                setMoneda(value)
                                            }}
                                            options={MonedaValores}
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>

                                    {moneda.value !== 'MXN' && moneda.value !== 'XXX' && (<FormGroup>
                                        <Label htmlFor="tipoCambio">Tipo de Cambio</Label>

                                        <Input
                                            name="tipoCambio"
                                            id="tipoCambio"
                                            value={tipoCambio}
                                            onChange={(e) => { setTipoCambio(e.target.value) }} />
                                    </FormGroup>)}
                                </Col>
                            </Row>

                            {showInformacionGlobalForm && (
                                <Row>
                                    <Col xs={12} sm={4} lg={3}>
                                        <FormGroup>
                                            <Label htmlFor="periodicidad">
                                                Periodicidad
                                            </Label>

                                            <Select
                                                value={informacionGlobal.Periodicidad}
                                                onChange={(value) => {
                                                    setInformacionGlobal({ ...informacionGlobal, Periodicidad: value })
                                                }}
                                                options={c_Periodicidad}
                                                classNamePrefix="select2-selection"
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col xs={12} sm={4} lg={3}>
                                        <FormGroup>
                                            <Label htmlFor="meses">
                                                Meses
                                            </Label>

                                            <Select
                                                value={informacionGlobal.Meses}
                                                onChange={(value) => {
                                                    setInformacionGlobal({ ...informacionGlobal, Meses: value })
                                                }}
                                                options={c_Meses}
                                                classNamePrefix="select2-selection"
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col xs={12} sm={4} lg={3}>
                                        <FormGroup>
                                            <Label htmlFor="año">
                                                Año
                                            </Label>

                                            <Select
                                                value={informacionGlobal.Año}
                                                onChange={(value) => {
                                                    setInformacionGlobal({ ...informacionGlobal, Año: value })
                                                }}
                                                options={[{
                                                    value: Moment().format('Y'),
                                                    label: Moment().format('Y')
                                                }, {
                                                    value: Moment().subtract(1, 'year').format('Y'),
                                                    label: Moment().subtract(1, 'year').format('Y')
                                                }]}
                                                classNamePrefix="select2-selection"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            )}
                        </Card>

                        <Card>
                            <Row>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label htmlFor="servicio">
                                            <span className="invoice-services-option">Mis Productos y Servicios</span>
                                        </Label>

                                        <Select
                                            data-testid="invoice-service"
                                            value={servicio}
                                            placeholder={`Productos frecuentes`}
                                            onChange={(value) => {
                                                selectService(value)
                                            }}
                                            options={servicios}
                                            classNamePrefix="select2-selection"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Card>

                        <Card>
                            <LineItemForm
                                tempItem={tempItem}
                                setTempItem={setTempItem}
                                claves={claves}
                                unidades={unidades}
                                aduanas={aduanas}
                                patentes={patentes}
                                impuestos={impuestos}
                                issuerRfc={props.profile?.empresa?.rfc}
                                customerRfc={cliente?.rfc}
                                onOpenAddClaveModal={() => setIsAddClaveModalOpen(true)}
                                onOpenAddClaveUnidadModal={() => setIsAddClaveUnidadModalOpen(true)}
                                onOpenAddAduanaModal={() => setIsAddAduanaModalOpen(true)}
                                onOpenAddPatenteModal={() => setIsAddPatenteModalOpen(true)}
                                onSubmit={_addLineItem}
                                submitLabel="Agregar Concepto"
                                formIdPrefix="add-line-item"
                                cfdiRelacionados={cfdiRelacionados}
                                tipoDeComprobante={tipoDeComprobante}
                                showCfdiRelacionadosForm={showCfdiRelacionadosForm}
                                onToggleCfdiRelacionadosForm={() => setShowCfdiRelacionadosForm(!showCfdiRelacionadosForm)}
                                onOpenAddRelacionModal={_openAddRelacionModal}
                                onRemoveRelacion={_removeRelacion}
                            />
                        </Card>

                        {lineItems.length > 0 && (
                            <Card>
                                <Table responsive striped>
                                    <thead>
                                        <tr>
                                            <th>Cantidad</th>
                                            <th>Clave SAT</th>
                                            <th>Unidad</th>
                                            {lineItems.some(item => item.NoIdentificacion) && (
                                            <th>No. Identificación</th>
                                            )}
                                            <th>Descripción</th>
                                            <th>Obj. Imp.</th>
                                            {lineItems.some(item => item.CuentaPredial) && (
                                                <th>Cuenta Predial</th>
                                            )}
                                            {lineItems.some(item => item.InformacionAduanera) && (
                                                <th>No. Pedimento</th>
                                            )}
                                            <th>Precio</th>
                                            {lineItems.some(li => li.Descuento > 0) && (
                                                <th>Desc.</th>
                                            )}
                                            <th>Importe</th>
                                            <th>...</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lineItems.map((item, key) => {
                                            const descuento = item.Descuento || 0
                                            const subtotal = (item.ValorUnitario * item.Cantidad) - descuento

                                            return (
                                                <tr key={key}>
                                                    <td>{item.Cantidad}</td>
                                                    <td>{item.ClaveProdServ}</td>
                                                    <td>{item.ClaveUnidad}</td>
                                                    {lineItems.some(lineItem => lineItem.NoIdentificacion) && (
                                                    <td>{item.NoIdentificacion}</td>
                                                    )}
                                                    <td>{item.Descripcion}</td>
                                                    <td>{item.ObjetoImp}</td>
                                                    {lineItems.some(lineItem => lineItem.CuentaPredial) && (
                                                        <td>{item.CuentaPredial}</td>
                                                    )}
                                                    {lineItems.some(lineItem => lineItem.InformacionAduanera) && (
                                                        <td>{item.InformacionAduanera}</td>
                                                    )}
                                                    <td>
                                                        <CurrencyFormat
                                                            value={item.ValorUnitario}
                                                            displayType="text"
                                                            thousandSeparator
                                                            prefix="$"
                                                            decimalScale={2}
                                                        />
                                                    </td>

                                                    {lineItems.some(li => li.Descuento > 0) && (
                                                        <td>
                                                            <CurrencyFormat
                                                                value={descuento}
                                                                displayType="text"
                                                                thousandSeparator
                                                                prefix="$"
                                                                decimalScale={2}
                                                            />
                                                        </td>
                                                    )}

                                                    <td>
                                                        <CurrencyFormat
                                                            value={subtotal}
                                                            displayType="text"
                                                            thousandSeparator
                                                            prefix="$"
                                                            decimalScale={2}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Button
                                                            type="button"
                                                            className="mr-1"
                                                            onClick={() => {
                                                                _openEditLineItemModal(key)
                                                            }}>
                                                            <i className="bx bxs-edit"></i>
                                                        </Button>
                                                        <Button
                                                            type="button"
                                                            onClick={() => {
                                                                _removeItem(key)
                                                            }}>
                                                            <i className="bx bxs-trash"></i>
                                                        </Button>
                                                    </td>
                                                </tr>
                                            )
                                        })}

                                        <tr>
                                            <td colSpan={lineItems.some(li => li.Descuento > 0) ? 7 : 6} style={{ border: "1px solid transparent" }}></td>
                                            <th>Subtotal:</th>
                                            <td className="importe">
                                                <CurrencyFormat
                                                    value={totales.subtotal}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                    decimalScale={2}
                                                />
                                            </td>
                                            <td></td>
                                        </tr>

                                        {totales.descuentos > 0 && (
                                            <tr>
                                                <td colSpan={lineItems.some(li => li.Descuento > 0) ? 7 : 6} style={{ border: "1px solid transparent" }}></td>
                                                <th>Descuento:</th>
                                                <td className="importe">
                                                    <CurrencyFormat
                                                        value={totales.descuentos}
                                                        displayType="text"
                                                        thousandSeparator
                                                        prefix="$"
                                                        decimalScale={2}
                                                    />
                                                </td>
                                                <td></td>
                                            </tr>
                                        )}

                                        {totales.retenciones.length > 0 && totales.retenciones.map((item, i) => (
                                            <tr key={i}>
                                                <td colSpan={lineItems.some(li => li.Descuento > 0) ? 7 : 6} style={{ border: "1px solid transparent" }}></td>
                                                <th>{item.label}</th>
                                                <td className="importe">
                                                    <CurrencyFormat
                                                        value={item.value}
                                                        displayType="text"
                                                        thousandSeparator
                                                        prefix="$"
                                                        decimalScale={2}
                                                    />
                                                </td>
                                                <td></td>
                                            </tr>
                                        ))}

                                        {totales.traslados.length > 0 && totales.traslados.map((item, i) => (
                                            <tr key={i}>
                                                <td colSpan={lineItems.some(li => li.Descuento > 0) ? 7 : 6} style={{ border: "1px solid transparent" }}></td>
                                                <th>{item.label}</th>
                                                <td className="importe">
                                                    <CurrencyFormat
                                                        value={item.value}
                                                        displayType="text"
                                                        thousandSeparator
                                                        prefix="$"
                                                        decimalScale={2}
                                                    />
                                                </td>
                                                <td></td>
                                            </tr>
                                        ))}

                                        <tr>
                                            <td colSpan={lineItems.some(li => li.Descuento > 0) ? 7 : 6} style={{ border: "1px solid transparent" }}></td>
                                            <th>Total:</th>
                                            <td className="importe">
                                                <CurrencyFormat
                                                    value={totales.total}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                    decimalScale={2}
                                                />
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Form>

            {isAddClaveModalOpen && (
                <Modal 
                    title={`Agregar Clave de Producto o Servicio`}
                    isOpen={isAddClaveModalOpen}
                    onRequestClose={closeAddClaveModal}
                    contentLabel={`Agregar Clave de Producto`}
                    body={
                        <AsyncTypeahead
                            id="clave-search"
                            ref={autosuggestRef}
                            isLoading={loading}
                            labelKey="descripcion"
                            minLength={1}
                            filterBy={(option, props) => {
                                const query = props.text.toLowerCase()

                                return (
                                    option.clave.toLowerCase().includes(query) ||
                                    option.descripcion.toLowerCase().includes(query)
                                )
                            }}
                            ignoreDiacritics={true}
                            onSearch={searchForProdServInSAT}
                            onChange={_addClaveProdServ}
                            options={autosuggest}
                            placeholder="Buscar clave de producto en SAT..."
                            renderMenuItemChildren={(option) => (
                                <div>
                                    <strong>{option.clave}</strong> - {option.descripcion}
                                </div>
                            )}
                        />
                    }
                    footer={
                        <Button color="secondary" variant="secondary" onClick={closeAddClaveModal}>
                            Cancelar
                        </Button>
                    }
                />
            )}

            {isAddClaveUnidadModalOpen && (
                <Modal 
                    title={`Agregar Clave de Unidad`}
                    isOpen={isAddClaveUnidadModalOpen}
                    onRequestClose={closeAddClaveUnidadModal}
                    contentLabel={`Agregar Clave de Unidad`}
                    body={
                        <AsyncTypeahead
                            id="clave-search"
                            ref={autosuggestRef}
                            isLoading={loading}
                            labelKey="descripcion"
                            minLength={1}
                            filterBy={(option, props) => {
                                const query = props.text.toLowerCase()

                                return (
                                    option.clave.toLowerCase().includes(query) ||
                                    option.descripcion.toLowerCase().includes(query)
                                )
                            }}
                            ignoreDiacritics={true}
                            onSearch={searchForUnidadInSAT}
                            onChange={_addClaveUnidad}
                            options={autosuggest}
                            placeholder="Buscar clave de unidad en SAT..."
                            renderMenuItemChildren={(option) => (
                                <div>
                                    <strong>{option.clave}</strong> - {option.descripcion}
                                </div>
                            )}
                        />
                    }
                    footer={
                        <Button color="secondary" variant="secondary" onClick={closeAddClaveUnidadModal}>
                            Cancelar
                        </Button>
                    }
                />
            )}

            {isAddAduanaModalOpen && (
                <Modal
                    title={`Agregar Aduana`}
                    isOpen={isAddAduanaModalOpen}
                    onRequestClose={closeAddAduanaModal}
                    contentLabel={`Agregar Aduana`}
                    body={
                        <AsyncTypeahead
                            id="aduana-search"
                            ref={aduanaAutosuggestRef}
                            isLoading={loading}
                            labelKey="descripcion"
                            minLength={1}
                            filterBy={(option, props) => {
                                const query = props.text.toLowerCase()

                                return (
                                    option.clave.toLowerCase().includes(query) ||
                                    option.descripcion.toLowerCase().includes(query)
                                )
                            }}
                            ignoreDiacritics={true}
                            onSearch={searchForAduanaInSAT}
                            onChange={_addAduanaRecord}
                            options={aduanaAutosuggest}
                            placeholder="Buscar aduana en catalogo maestro..."
                            renderMenuItemChildren={(option) => (
                                <div>
                                    <strong>{option.clave}</strong> - {option.descripcion}
                                </div>
                            )}
                        />
                    }
                    footer={
                        <>
                            <Button type="button" color="secondary" variant="secondary" onClick={closeAddAduanaModal}>
                                Cancelar
                            </Button>
                        </>
                    }
                />
            )}

            {isAddPatenteModalOpen && (
                <Modal
                    title={`Agregar Patente Aduanal`}
                    isOpen={isAddPatenteModalOpen}
                    onRequestClose={closeAddPatenteModal}
                    contentLabel={`Agregar Patente Aduanal`}
                    body={
                        <AsyncTypeahead
                            id="patente-search"
                            ref={patenteAutosuggestRef}
                            isLoading={loading}
                            labelKey="descripcion"
                            minLength={1}
                            filterBy={(option, props) => {
                                const query = props.text.toLowerCase()

                                return (
                                    option.clave.toLowerCase().includes(query) ||
                                    option.descripcion.toLowerCase().includes(query)
                                )
                            }}
                            ignoreDiacritics={true}
                            onSearch={searchForPatenteInSAT}
                            onChange={_addPatenteRecord}
                            options={patenteAutosuggest}
                            placeholder="Buscar patente en catalogo maestro..."
                            renderMenuItemChildren={(option) => (
                                <div>
                                    <strong>{option.clave}</strong> - {option.descripcion}
                                </div>
                            )}
                        />
                    }
                    footer={
                        <>
                            <Button type="button" color="secondary" variant="secondary" onClick={closeAddPatenteModal}>
                                Cancelar
                            </Button>
                        </>
                    }
                />
            )}

            {isEditLineItemModalOpen && (
                <Modal
                    title={`Editar Concepto`}
                    isOpen={isEditLineItemModalOpen}
                    onRequestClose={closeEditLineItemModal}
                    contentLabel={`Editar Concepto`}
                    body={
                        <LineItemForm
                            tempItem={editTempItem}
                            setTempItem={setEditTempItem}
                            claves={claves}
                            unidades={unidades}
                            aduanas={aduanas}
                            patentes={patentes}
                            impuestos={impuestos}
                            issuerRfc={props.profile?.empresa?.rfc}
                            customerRfc={cliente?.rfc}
                            onOpenAddClaveModal={() => setIsAddClaveModalOpen(true)}
                            onOpenAddClaveUnidadModal={() => setIsAddClaveUnidadModalOpen(true)}
                            onOpenAddAduanaModal={() => setIsAddAduanaModalOpen(true)}
                            onOpenAddPatenteModal={() => setIsAddPatenteModalOpen(true)}
                            onSubmit={_updateLineItem}
                            submitLabel="Guardar Cambios"
                            formIdPrefix="edit-line-item"
                            showSubmitButton={false}
                            layout="modal"
                        />
                    }
                    styles={{
                        content: {
                            width: '60vw',
                            maxWidth: '1100px',
                            minWidth: '320px',
                            maxHeight: '88vh',
                            overflow: 'auto'
                        }
                    }}
                    footer={
                        <>
                            <Button type="button" color="secondary" variant="secondary" onClick={closeEditLineItemModal}>
                                Cancelar
                            </Button>
                            <Button type="button" color="primary" variant="primary" onClick={_updateLineItem}>
                                Guardar cambios
                            </Button>
                        </>
                    }
                />
            )}

            {isModalPreviewOpen && (
                <Modal 
                    isOpen={isModalPreviewOpen}
                    onRequestClose={closeModal}
                    contentLabel={`Previsualización de Factura`}
                    body={
                        <embed src={previewPDF} type="application/pdf" width="100%" height="600px" />
                    }
                    footer={<Button color="secondary" variant="secondary" onClick={closeModal}>Cerrar</Button>}
                />
            )}

            {programarFacturaModalOpen && facturaIdToSchedule && (
                <ProgramarFacturaModal
                    facturaId={facturaIdToSchedule}
                    isOpen={programarFacturaModalOpen}
                    history={props.history}
                    title={scheduleStatus === 'programada' || scheduleStatus === 'fallida' ? 'Actualizar programación' : 'Programar Factura'}
                    submitLabel={scheduleStatus === 'programada' || scheduleStatus === 'fallida' ? 'Guardar cambios' : 'Programar'}
                    initialSchedule={currentSchedule}
                    onRequestClose={() => setProgramarFacturaModalOpen(false)}
                />
            )}

            {isAddRelacionModalOpen && (
                <Modal
                    title="Seleccionar CFDI Relacionado"
                    isOpen={isAddRelacionModalOpen}
                    onRequestClose={_closeAddRelacionModal}
                    contentLabel="Seleccionar CFDI Relacionado"
                    body={
                        <div>
                            {/* Tipo de Relación */}
                            <FormGroup>
                                <Label>Tipo de Relación</Label>
                                <Select
                                    value={newRelacionTipoRelacion}
                                    onChange={(value) => setNewRelacionTipoRelacion(value)}
                                    options={c_TipoRelacion}
                                    isDisabled={tipoDeComprobante === 'E'}
                                    classNamePrefix="select2-selection"
                                />
                                {tipoDeComprobante === 'E' && (
                                    <small className="text-muted">Para Notas de Crédito el tipo de relación es siempre 01 — Nota de crédito.</small>
                                )}
                            </FormGroup>

                            <hr className="my-3" />

                            {/* Search + cliente filter */}
                            <Row className="mb-2">
                                <Col md={6}>
                                    <Input
                                        placeholder="Buscar por folio o UUID..."
                                        value={modalRelacionSearch}
                                        onChange={_onModalRelacionSearchChange}
                                    />
                                </Col>
                                <Col md={6}>
                                    <Select
                                        options={clientes}
                                        value={modalRelacionCliente}
                                        onChange={_onModalRelacionClienteChange}
                                        placeholder="Filtrar por cliente..."
                                        isClearable
                                        isDisabled={cfdiRelacionados.length > 0}
                                        classNamePrefix="select2-selection"
                                    />
                                    {cfdiRelacionados.length > 0 && (
                                        <small className="text-muted">El cliente está fijo porque ya tienes CFDIs relacionados.</small>
                                    )}
                                </Col>
                            </Row>

                            {/* Past-years toggle */}
                            <Row className="mb-3 align-items-center">
                                <Col>
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="chkRelacionPastYears"
                                            checked={modalRelacionPastYears}
                                            onChange={_onToggleModalRelacionPastYears}
                                        />
                                        <label className="form-check-label" htmlFor="chkRelacionPastYears">
                                            Incluir años anteriores
                                        </label>
                                    </div>
                                    {modalRelacionPastYears && (
                                        <span className="badge badge-info ml-2">Mostrando todos los años</span>
                                    )}
                                </Col>
                                {!modalRelacionLoading && (
                                    <Col className="text-right text-muted" style={{ fontSize: '0.85em' }}>
                                        {modalRelacionTotal} {modalRelacionTotal === 1 ? 'resultado' : 'resultados'}
                                    </Col>
                                )}
                            </Row>

                            {/* Results table */}
                            <Table hover size="sm" responsive>
                                <thead>
                                    <tr>
                                        <th>Folio</th>
                                        <th>Cliente</th>
                                        <th>Fecha</th>
                                        <th className="text-right">Total</th>
                                        <th>F. Pago</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {modalRelacionLoading ? (
                                        Array.from({ length: 5 }).map((_, i) => (
                                            <tr key={i}>
                                                {Array.from({ length: 5 }).map((__, j) => (
                                                    <td key={j}>
                                                        <div className="bg-light rounded" style={{ height: 16, width: '80%' }} />
                                                    </td>
                                                ))}
                                            </tr>
                                        ))
                                    ) : modalRelacionFacturas.length === 0 ? (
                                        <tr>
                                            <td colSpan={5} className="text-center text-muted py-3">
                                                No se encontraron facturas
                                            </td>
                                        </tr>
                                    ) : (
                                        modalRelacionFacturas.map(f => {
                                            const alreadyAdded = cfdiRelacionados.some(r => r.uuid === f.uuid)
                                            return (
                                                <tr
                                                    key={f._id}
                                                    onClick={() => !alreadyAdded && _addRelacionFromRow(f)}
                                                    style={{
                                                        cursor:  alreadyAdded ? 'not-allowed' : 'pointer',
                                                        opacity: alreadyAdded ? 0.45 : 1
                                                    }}
                                                    title={alreadyAdded ? 'Ya agregado' : f.uuid}
                                                >
                                                    <td>{f.folio || '—'}</td>
                                                    <td>{f.receptor?.razonSocial || '—'}</td>
                                                    <td>{f.fecha ? new Date(f.fecha).toLocaleDateString('es-MX') : '—'}</td>
                                                    <td className="text-right">${numberFormat(parseFloat(f.total) || 0, 2, '.', ',')}</td>
                                                    <td>{f.formaPago || '—'}</td>
                                                </tr>
                                            )
                                        })
                                    )}
                                </tbody>
                            </Table>

                            {/* Pagination */}
                            {modalRelacionTotalPages > 1 && (
                                <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        disabled={modalRelacionPage <= 1 || modalRelacionLoading}
                                        onClick={() => _fetchFacturasTimbradas(
                                            modalRelacionPage - 1,
                                            modalRelacionCliente?.value || null,
                                            modalRelacionSearch,
                                            modalRelacionPastYears
                                        )}
                                    >
                                        ← Anterior
                                    </button>
                                    <span className="text-muted" style={{ fontSize: '0.85em' }}>
                                        Página {modalRelacionPage} de {modalRelacionTotalPages}
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        disabled={modalRelacionPage >= modalRelacionTotalPages || modalRelacionLoading}
                                        onClick={() => _fetchFacturasTimbradas(
                                            modalRelacionPage + 1,
                                            modalRelacionCliente?.value || null,
                                            modalRelacionSearch,
                                            modalRelacionPastYears
                                        )}
                                    >
                                        Siguiente →
                                    </button>
                                </div>
                            )}

                        </div>
                    }
                    footer={
                        <Button type="button" variant="secondary" onClick={_closeAddRelacionModal}>
                            Cerrar
                        </Button>
                    }
                />
            )}

            {isConfirmRelacionModalOpen && (
                <Modal
                    isOpen={isConfirmRelacionModalOpen}
                    onRequestClose={_cancelRelacionChangeCustomer}
                    title="¿Cambiar cliente?"
                    contentLabel="Cambiar cliente relacionado"
                    body={
                        <p>
                            Los CFDIs que ya relacionaste pertenecen a{' '}
                            <strong>{cliente?.label || 'el cliente actual'}</strong>.
                            <br /><br />
                            Si agregas esta factura, se eliminarán los CFDIs relacionados y
                            se asignará el cliente{' '}
                            <strong>{pendingRelacion?.receptor?.razonSocial || 'nuevo'}</strong>.
                            <br /><br />
                            ¿Deseas continuar?
                        </p>
                    }
                    footer={
                        <div className="d-flex justify-content-end" style={{ gap: 8 }}>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={_cancelRelacionChangeCustomer}
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={_confirmRelacionChangeCustomer}
                            >
                                Sí, cambiar cliente
                            </button>
                        </div>
                    }
                />
            )}

            <BillingPaywallModal
                isOpen={Boolean(pendingStampRequest)}
                onRequestClose={() => setPendingStampRequest(null)}
                onActivated={retryStampAfterPayment}
            />
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return { profile: state.Auth.profile }
}

export default connect(
    mapStatetoProps, {}
)(withRouter(FormPage))
